import { Formik } from "formik";
import {useCallback, useMemo, useState} from "react";
import { Form, Button, Typography, Input, Upload } from "antd";

import {FormItem, RadioGroup, SelectSearch} from "components";

import {deleteBatteryModel, deleteOrganization, setModalName} from "store/actions";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../store";


const { Title, Text } = Typography;

export default function DeleteOrganizationForm() {
    const{
        organizations: {selectedOrganization},
        common: { userType =1 },
    } = useSelector<AppState, AppState>((state) => state);
    const dispatch = useDispatch();
    const onCancels = useCallback(() => {
        dispatch(setModalName(undefined));
    }, [dispatch]);
    const onDelete = useCallback(() => {
        console.log("Selected Organization ID : ", selectedOrganization?.id)
        dispatch(
            deleteOrganization({id:selectedOrganization?.id || ""})
        )
        onCancels();
    }, [dispatch, selectedOrganization?.id]);
    return (
        <section className="delete-modal">
            <Title level={5}>Delete Client</Title>
            <Text type="secondary">
                Are you sure you want to delete {" "}
                <strong>
                    “{selectedOrganization?.name}”
                </strong>{" "}
                ?
            </Text>
            <div className="action-btn-container">
                <Button className="cancel-btn" onClick={onCancels}>
                    Cancel
                </Button>
                <Button type="primary" danger onClick={onDelete}>
                    Delete
                </Button>
            </div>
        </section>
    );
}